import React from 'react';
import { Link } from 'gatsby';

const CustomerCareList = () => (
  <ul className="m-0 p-0">
    <li className="text-sm text-foreground-muted py-2 uppercase text-center list-none md:text-left">
      <Link
        to="/contact-us"
        className="text-foreground-muted no-underline hover:underline"
      >
        Contact Us
      </Link>
    </li>
    <li className="text-sm text-foreground-muted py-2 uppercase text-center list-none md:text-left">
      <a
        href="https://www.sportdog.com/where-to-buy/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-foreground-muted no-underline hover:underline"
      >
        Find A Retailer
      </a>
    </li>
  </ul>
);

export default CustomerCareList;
